import { useNavigate } from 'react-router';
import { Body, Col, Row, Heading, Stack, Button } from '@workramp/ui';

import { I18n } from '~/common/explicit-exports';

import { IntegrationHeaderStyled, IntegrationBackLink } from './IntegrationHeader.styles';

export interface IntegrationHeaderProps {
  baseUrl: string;
  icon: React.ReactNode;
  name: string;
  description: React.ReactNode;
  actions?: React.ReactNode;
}

export const IntegrationHeader = ({ baseUrl, name, description, icon, actions }: IntegrationHeaderProps) => {
  const navigate = useNavigate();
  const handlePress = () => {
    navigate(baseUrl);
  };
  return (
    <IntegrationHeaderStyled>
      <Stack size={8}>
        <IntegrationBackLink>
          <Button variant="text" size="sm" color="secondary" leadingIconName="arrow-left:regular" onPress={handlePress}>
            {I18n.t('js.admin.integration_settings.common.title')}
          </Button>
        </IntegrationBackLink>
        <Row align="flex-start">
          <Col xs="auto">{icon}</Col>
          <Col>
            <Stack size={2}>
              <Heading as="h2" level="md">
                {name}
              </Heading>
              <Body level="md">{description}</Body>
            </Stack>
          </Col>
          <Col xs="auto">{actions}</Col>
        </Row>
        <hr />
      </Stack>
    </IntegrationHeaderStyled>
  );
};
